<template>
  <div >

    <!--<div style="position: relative; z-index: -1" width="100%">-->
    <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
    <!--</div>-->




    <div style="width:100%">
      <nav-bar></nav-bar>
    </div>

    <!-------------------------------------------------------Forecasts----------------------------------------------->
    <Section background="white" class="pt-0 ml-1 mr-1">
      <!--<v-toolbar light  >-->
        <!--&lt;!&ndash;<v-app-bar-nav-icon></v-app-bar-nav-icon>&ndash;&gt;-->

        <!--&lt;!&ndash;<v-toolbar-title style="text-align: center; width:100%;">COVID-19 Forecasting Model (Calibrated To US Data)</v-toolbar-title>&ndash;&gt;-->

        <!--<v-spacer></v-spacer>-->



        <!--<v-btn dark small @click="toggle_viewMode" :color="colors['Model-Adjusted']">-->
          <!--{{btn_toggle_txt}}-->
        <!--</v-btn>-->
      <!--</v-toolbar>-->





      <v-container fluid pb-0 >
        <div style="text-align: center">
          <p style="font-size: 1.5em"> COVID-19 Forecasting Model (Calibrated To US Data)</p>

        </div>

        <v-row  justify="center" align="center">



          <!--<v-col cols="12" md="6" justify="center" v-if="show_short">-->
            <!--<covid-chart-->
                    <!--:data="data2"-->
                    <!--:options="c3_options2"-->
                    <!--title="Historical: Total US Confirmed Cases"-->
                    <!--elem-id="covidChart2"-->
                    <!--key="covidChart2"-->
            <!--&gt;</covid-chart>-->

          <!--</v-col>-->

          <v-col cols="12" md="6" justify="center" v-if="show_long">

            <covid-chart
                    :data="data1"
                    :options="c3_options1"
                    title="Active Infections"
                    elem-id="covidChart1"
                    key="covidChart1"
            ></covid-chart>
          </v-col>

          <v-col cols="12" md="6" justify="center" v-if="show_deaths">

            <covid-chart
                    :data="data_deaths"
                    :options="c3_options1"
                    title="Cumulative Deaths"
                    elem-id="covidChart3"
                    key="covidChart3"
            ></covid-chart>
          </v-col>

          <!--<v-col cols="12" md="6" justify="center" v-if="show_ICU">-->

            <!--<covid-chart-->
                    <!--:data="data_hospitals"-->
                    <!--:options="c3_options1"-->
                    <!--title="ICU Need vs Capacity"-->
                    <!--elem-id="covidHospitalBeds"-->
                    <!--key="covidHospitalBeds"-->
            <!--&gt;</covid-chart>-->
          <!--</v-col>-->

          <!--<v-col cols="12" md="6" justify="center" v-if="show_ICU">-->

            <!--<covid-chart-->
                    <!--:data="data_hospitals"-->
                    <!--:options="c3_options1"-->
                    <!--title="ICU Need vs Capacity (Cumulative)"-->
                    <!--elem-id="covidHospitalBedsTotal"-->
                    <!--key="covidHospitalBedsTotal"-->
            <!--&gt;</covid-chart>-->
          <!--</v-col>-->


          <v-col cols="12" md="6" justify="center"  v-if="show_full" >
            <covid-chart
                    :data="data_all"
                    :options="c3_options1"
                    title="Full Model"
                    elem-id="covidChart4"
                    key="covidChart4"
            ></covid-chart>

          </v-col>




          <v-col cols="12" md="6" justify="center" v-if="nerdMode">
            <covid-chart
                    :data="data_hist"
                    :options="c3_options2"
                    title="Back Test: Confirmed Cases"
                    elem-id="covidChart5"
                    key="covidChart5"
            ></covid-chart>

          </v-col>
          <v-col cols="12" md="6" justify="center" v-if="nerdMode">
            <covid-chart
                    :data="data_growth"
                    :options="c3_options2"
                    title="Back Test: Growth Rate (Confirmed Cases)"
                    elem-id="covidChart6"
                    key="covidChart6"
            ></covid-chart>
          </v-col>



        </v-row>

        <!--<v-row style="font-size: small; width:100%; padding:0px;">-->
          <!--<v-spacer></v-spacer>-->
          <!--Last Update: {{updated_str}}-->
        <!--</v-row>-->

      </v-container>


      <!-----------------------------------controls for charts--------------------------------------------------------->


        <v-container style="max-width: 1200px; position:relative;" class="pt-0" id="chartControls" ref="chartConrols">
          <v-card light >


            <div class="pl-2 pt-2">Social Distancing Parameters</div>


          <v-row class="pt-0 slider-box">

            <v-col style="position:relative;" cols="12" sm="6"   >
              <div class="slider_ranges" ref="sliderwidth" key="slider1">
                <svg width="100%" height="100%">
                  <text
                          v-if="!show_animation"
                          y="14"
                          :x="ranges_cp.x_baseline"
                          text-anchor="middle"
                          :style="annotation_txt_style"
                  >{{annotation_txt_no_social}}</text>
                  <text
                          v-if="!show_animation"
                          y="14"
                          :x="ranges_cp.x_current"
                          text-anchor="middle"
                          :style="annotation_txt_style"
                  >Current Level</text>

                  <circle
                          r="7"
                          :cx="ranges_cp.x_baseline"
                          cy="28"
                          class="dot"
                  ></circle>

                  <circle
                          r="7"
                          :cx="ranges_cp.x_current"
                          cy="28"
                          class="dot"
                  ></circle>
                </svg>

              </div>
              <highlight v-if="show_animation"></highlight>
              <v-row>
                <v-slider
                        v-model="contactProb"
                        class="align-center"
                        :max="contactProb_max"
                        :min="contactProb_min"
                        :step="contactProb_step"
                        hide-details
                        light
                        thumb-label
                        tick-size="0"
                        @click="show_animation=false"
                >
                </v-slider>
              </v-row>
              <v-row  class="slider-text pl-2">
                Contact Probability ({{contactProb}}%)
              </v-row>
            </v-col>


            <!--</v-row>-->




            <!--<v-row class="pt-0 slider-box">-->


            <v-col cols="12" sm="6" style="position:relative;">

              <slider-labels
                      :labels="ranges_daysEffect"
              ></slider-labels>

              <v-row>
                <v-slider
                        v-model="daysInEffect"
                        class="align-center"
                        :max="days_max"
                        :min="days_min"
                        step="5"
                        hide-details
                        light
                        thumb-label
                        :color="colors['Social Distancing Period']"
                        :track-color="colors['Social Distancing Period light']"
                >
                </v-slider>
              </v-row>
              <v-row class="slider-text pl-3">
                Quarantine Duration ({{daysInEffect}} Days)
              </v-row>
            </v-col>

            <v-col cols="12" sm="6" v-if="show_startDay">
              <v-row>
                <v-slider
                        v-model="dayToStart"
                        class="align-center"
                        :max="day_max"
                        :min="day_min"
                        hide-details
                        light
                        thumb-label
                        :color="colors['Social Distancing Period']"
                        :track-color="colors['Social Distancing Period light']"
                >
                </v-slider>
              </v-row>
              <v-row  class="slider-text pl-2">
                Intervention Start (In {{dayToStart}} Days)
              </v-row>
            </v-col>


            <v-col cols="12" sm="6" style="position:relative;" v-if="show_DaysNormal">

              <slider-labels
                      :labels="ranges_daysEffect"
              ></slider-labels>
              <v-row>
                <v-slider
                        v-model="daysToReturn"
                        class="align-center"
                        :max="daysToReturn_max"
                        :min="daysToReturn_min"
                        hide-details
                        light
                        thumb-label
                        :color="colors['Social Distancing Period']"
                        :track-color="colors['Social Distancing Period light']"
                >
                </v-slider>
              </v-row>
              <v-row  class="slider-text pl-2">
                Days To get Back to normal ({{daysToReturn}} Days)
              </v-row>
            </v-col>

            <v-col cols="12" sm="6" style="position:relative;" v-if="show_fcstDays">
              <slider-labels
                      :labels="ranges_fcstDays"
              ></slider-labels>
              <v-row>
                <v-slider
                        v-model="fcstDays"
                        class="align-center"
                        :max="fcstDays_max"
                        :min="fcstDays_min"
                        hide-details
                        light
                        thumb-label
                        :color="colors['Social Distancing Period']"
                        :track-color="colors['Social Distancing Period light']"
                >
                </v-slider>
              </v-row>
              <v-row  class="slider-text pl-2">
                Forecast Length ({{fcstDays}} Days)
              </v-row>
            </v-col>


          </v-row>
          </v-card>













          <v-card light class="mt-2" v-if="show_deathRate || show_transProb || show_T_sick">
            <div class="pl-2 pt-2">Other Model Parameters</div>
            <v-row class="pt-0 slider-box">






            <v-col cols="12" sm="6" style="position:relative;" v-if="show_deathRate">
              <div class="slider_ranges" ref="sliderwidth0" key="slider2">
                <svg width="100%" height="100%">

                  <text

                          y="14"
                          :x="ranges_pd.x_baseline"
                          text-anchor="middle"
                          :style="annotation_txt_style"
                  >Current Est.</text>
                  <text

                          y="14"
                          :x="ranges_pd.x_flu"
                          text-anchor="middle"
                          :style="annotation_txt_style"
                  >Flu</text>


                  <circle
                          r="7"
                          :cx="ranges_pd.x_baseline"
                          cy="28"
                          class="dot"
                  ></circle>
                  <circle
                          r="7"
                          :cx="ranges_pd.x_flu"
                          cy="28"
                          class="dot"
                  ></circle>
                </svg>

              </div>
              <v-row>
                <v-slider
                        v-model="deathRate"
                        class="align-center"
                        :max="deathRate_max"
                        :min="deathRate_min"
                        step="0.1"
                        hide-details
                        light
                        thumb-label
                >
                </v-slider>
              </v-row>

              <v-row class="slider-text pl-3">
                Mortality Rate ({{deathRate}}%)
              </v-row>
            </v-col>











            <v-col cols="12" sm="6" style="position:relative;" v-if="show_transProb">

              <slider-labels
                      :labels="ranges_transProb"
              ></slider-labels>
              <v-row>
                <v-slider
                        v-model="transProb"
                        class="align-center"
                        :max="transProb_max"
                        :min="transProb_min"
                        hide-details
                        light
                        thumb-label
                        :color="colors['Social Distancing Period']"
                        :track-color="colors['Social Distancing Period light']"
                >
                </v-slider>
              </v-row>
              <v-row  class="slider-text pl-2">
                Transmission Probability ({{transProb}}%)
              </v-row>
            </v-col>



            <v-col cols="12" sm="6" style="position:relative;" v-if="show_T_sick">
              <slider-labels
                      :labels="ranges_T_sick"
              ></slider-labels>
              <v-row>
                <v-slider
                        v-model="T_sick"
                        class="align-center"
                        :max="T_sick_max"
                        :min="T_sick_min"
                        hide-details
                        light
                        thumb-label
                        :color="colors['Social Distancing Period']"
                        :track-color="colors['Social Distancing Period light']"
                >
                </v-slider>
              </v-row>
              <v-row  class="slider-text pl-2">
                Infectious Period ({{T_sick}} Days)
              </v-row>
            </v-col>









          </v-row>



          </v-card>


        </v-container>





      <v-container style="max-width: 1200px; position:relative;" class="pt-0" >
        <v-expansion-panels id="chartSettings">
          <v-expansion-panel>
            <v-expansion-panel-header>Settings

            </v-expansion-panel-header>
            <v-expansion-panel-content>


              <!--<v-btn dark small @click="toggle_viewMode" :color="colors['Model-Forecast']" class="ma-2">-->
              <!--{{btn_toggle_txt}}-->
              <!--</v-btn>-->

              <!--<v-btn dark small @click="reset_settings" :color="colors['Model-Forecast']" class="ma-2">-->
              <!--Reset Settings to Defaults-->
              <!--</v-btn>-->

              <!--<v-btn dark small @click="toggle_nerd" :color="colors['Model-Forecast']" class="ma-2">-->
              <!--{{btn_nerd_txt}}-->
              <!--</v-btn>-->
              <v-divider></v-divider>
              <div class="settings-title">Charts To Show</div>
              <v-container fluid class="pa-0 ma-0">


                <v-row dense align="start" justify="start" no-gutters>
                  <!--<v-col>-->
                  <!--<v-btn dark small @click="toggle_viewMode" :color="colors['Model-Forecast']" class="ma-2">-->
                  <!--{{btn_toggle_txt}}-->
                  <!--</v-btn>-->
                  <!--</v-col>-->
                  <!--<v-col>-->
                  <!--<v-btn dark small @click="toggle_nerd" :color="colors['Model-Forecast']" class="ma-2">-->
                  <!--{{btn_nerd_txt}}-->
                  <!--</v-btn>-->
                  <!--</v-col>-->




                  <!--<v-switch-->
                  <!--v-model="show_short"-->
                  <!--class="pa-2"-->
                  <!--label="Actual/Short Term"-->
                  <!--:color="colors['Model-Forecast']"-->
                  <!--dark-->
                  <!--hide-details-->
                  <!--&gt;</v-switch>-->

                  <v-switch
                          v-model="show_long"
                          class="pa-2  mt-0"
                          label="Active Cases"
                          :color="colors['Model-Forecast']"
                          dark
                          hide-details
                  ></v-switch>

                  <v-switch
                          v-model="show_deaths"
                          class="pa-2  mt-0"
                          label="Total Deaths"
                          :color="colors['Model-Forecast']"
                          dark
                          hide-details
                  ></v-switch>

                  <v-switch
                          v-model="show_full"
                          class="pa-2  mt-0"
                          label="Full Model"
                          :color="colors['Model-Forecast']"
                          dark
                          hide-details
                  ></v-switch>



                  <!--<v-switch-->
                  <!--v-model="show_ICU"-->
                  <!--class="pa-2"-->
                  <!--label="ICU Fcst"-->
                  <!--:color="colors['Model-Forecast']"-->
                  <!--dark-->
                  <!--hide-details-->
                  <!--&gt;</v-switch>-->
                  <v-switch
                          v-model="nerdMode"
                          class="pa-2 mt-0"
                          label="Back Tests"
                          :color="colors['Model-Forecast']"
                          dark
                          hide-details
                  ></v-switch>
                  <v-spacer></v-spacer>

                </v-row>










                <v-divider></v-divider>
                <div class="settings-title">Controls for Social Distancing Parameters</div>
                <v-row dense align="center" no-gutters class="p">

                  <!--<v-switch-->
                  <!--v-model="show_startDay"-->
                  <!--class="pa-2"-->
                  <!--label="Intervention Start"-->
                  <!--:color="colors['Model-Forecast']"-->
                  <!--dark-->
                  <!--hide-details-->
                  <!--&gt;</v-switch>-->



                  <v-switch
                          v-model="show_DaysNormal"
                          class="pa-2 mt-0"
                          label="Days To Normal"
                          :color="colors['Model-Forecast']"
                          dark
                          hide-details
                          dense
                  ></v-switch>
                  <v-switch
                          v-model="show_fcstDays"
                          class="pa-2  mt-0"
                          label="Forecast Length"
                          :color="colors['Model-Forecast']"
                          step="5"
                          dark
                          hide-details
                          dense
                  ></v-switch>


                </v-row>

                <v-divider></v-divider>
                <div class="settings-title">Controls for Other Model Parameters</div>
                <v-row dense align="center" no-gutters>

                  <v-switch
                          v-model="show_deathRate"
                          class="pa-2   mt-0"
                          label="Mortality Rate"
                          :color="colors['Model-Forecast']"
                          dark
                          hide-details
                  ></v-switch>

                  <v-switch
                          v-model="show_transProb"
                          class="pa-2   mt-0"
                          label="Transmission Probability"
                          :color="colors['Model-Forecast']"
                          dark
                          hide-details
                  ></v-switch>

                  <v-switch
                          v-model="show_T_sick"
                          class="pa-2   mt-0"
                          label="Days Infectious"
                          :color="colors['Model-Forecast']"
                          dark
                          hide-details
                  ></v-switch>



                  <v-spacer></v-spacer>
                </v-row>
              </v-container>




            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>


      </v-container>
      <v-row style="font-size: small; width:100%; padding:0px;">
        <v-spacer></v-spacer>
        Last Update: {{updated_str}}
      </v-row>

    </Section>



    <div class="pa-2" id="chartSettingsBottom"></div>
































    <!-----------------------------------------instructions tab-------------------------------------------------------->
    <section-content title="INSTRUCTIONS" :no-side="noSide">
      <div class="title pb-2">
        How To Use
      </div>
      <p>
        Adjust the sliders for the Contact Probability and Intervention Duration.
        Additional charts/parameters can be accessed in the settings menu.

        The impact of changing these parameters will be shown relative to the baseline forecast which is based
        on the Contact Probability estimated before social distancing went into effect.

        For mobile users, please tap on where you want the slider to be if you experience issues.
      </p>

      <p>
        Note that the graphs are interactive.  Mouse over to see additional details.
        In addition clicking on legend items will show/hide the associated data series.
      </p>

      <p>A full description of the model is available <a v-bind:href="url_report">here</a>.</p>

      <div class="title pb-2">
      Definitions
      </div>

      <div class="def-container">
        <span class="definition">Contact Probability: </span>
        The probability that any two people in the population interact with each other in way that could potentially
        transmit the virus.  This is the variable that we can control through social mitigations like social distancing.
        The baseline or "No Social Distancing" value of 92% is based on calibrating the model to data
        prior to March 22, 2020 and gives an estimate of our social interaction before we started limiting it.
        <!--Data Source: <a href="https://github.com/CSSEGISandData/COVID-19">John Hopkins University</a>.-->

      </div>

      <div class="def-container">
        <span class="definition">Quarantine Duration:</span> The number of days the social distancing policies will remain in effect.
        The model will apply the user specified contact probability over this period.  The period is shown in the
        "Active Infections" chart.

      </div>

      <div class="def-container">
        <span class="definition">Mortality Rate: </span>
        The percent of the individuals who die as a result of becoming sick with COVID-19.  Estimates vary but at
        present we think 0.5% is a reasonable estimate based on what we know today. See for instance this
        <a href="https://www.nejm.org/doi/full/10.1056/NEJMe2002387?query=recirc_curatedRelated_article">editorial</a>
        by Dr Fauci, et. al, where they discuss COVID-19's mortality rate.
      </div>



      <div class="def-container">
        <span class="definition">Days to Normal:</span>
        The number of days over which to ease social distancing restrictions. For values > 0, the model will linearly
        gradually adjust the contact probability from the current user specified value to the baseline (No social distaning) value.

        If the value is 0, then the  model will immediately revert the contact probability to the baseline level, once
        the quarantine duration is ended.

      </div>

      <!--<div class="def-container">-->
        <!--<span class="definition">Intervention Start: </span> The number of days (from today) to enact the intervention policies.-->

      <!--</div>-->





      <div class="title pb-2 pt-5">
        Chart Legends
      </div>

      <div class="def-container">
        <span class="definition">Model-Baseline:</span> Model's prediction based on parameters calibrated to the
        current data for US confirmed cases.

      </div>

      <div class="def-container">
        <span class="definition">Model-Forecast:</span> The model's forecast based on the Contact Probability specified
        by the user and applied over the Intervention Period shown in the first chart.  Note that the baseline
        value of the Contact Probability is
        used for times outside of the Intervention Period.
      </div>

      <div class="def-container">
        <span class="definition">Intervention Period:</span> The period over which the user specified Contact
        Probability is applied.

      </div>

      <div class="def-container">
        <span class="definition">Actual:</span> The reported number of US confirmed cases,
        as reported by <a href="https://github.com/CSSEGISandData/COVID-19">John Hopkins University</a>.

      </div>

      <div class="def-container">
        <span class="definition">Total Population:</span> The total US population (assumed to be 330 million).

      </div>

      <div class="def-container">
        <span class="definition">Susceptible:</span> The total number of able to become infected with the virus.
        Initially we assume the entire population is susceptible.

      </div>

      <div class="def-container">
        <span class="definition">Infected:</span> The number of people who are infected and infectious, i.e. can
        get other people infected.
      </div>

      <div class="def-container">
        <span class="definition">Recovered:</span> The number of people who got the virus, recovered and are now
        assumed immune to it.
      </div>

      <div class="def-container">
        <span class="definition">Deaths:</span> The cumulative number of deaths that results from the virus.  Based on the
        the mortality rate.

      </div>





      <!--<div class="title">-->
        <!--References-->
      <!--</div>-->
      <!--<refs  :refs="bib"></refs>-->
    </section-content>

    <div class="pa-2"></div>

    <!-------------------------------------------Section: The Model---------------------------------------------------->

    <a id="services-consulting"></a>






    <!-- dialog for reference------>
    <v-dialog v-model="show_dialog_ref" max-width="70%" >


      <v-card>
        <v-card-title>
          1 Data Science Success Rates
        </v-card-title>
        <v-card-text style="color: white">


          <p>
            According to a review article by Designing For Analytics, the success rate for data analytics projects varies
            from about 13% (VentureBeat AI) to 26% (Cisco) depending on the reporting source.
          </p>

          <p>
            According to a study by PWC (reported by CIO magazine),
            <span style="font-style: italic">Overall, 43 percent of companies surveyed "obtain little tangible benefit
              from their information," while 23 percent "derive no benefit whatsoever," according to the study.</span>
          </p>

          <p>
            See references below for more information
          </p>

          Source: Designing for Analytics, "Failure rates for analytics, AI, and big data projects = 85% – yikes!", July 2019 <br>
          <a href="https://designingforanalytics.com/resources/failure-rates-for-analytics-bi-iot-and-big-data-projects-85-yikes/"
             target="_blank">
            https://designingforanalytics.com/resources/failure-rates-for-analytics-bi-iot-and-big-data-projects-85-yikes/
          </a>

          <br>
          Source: CIO Magazine, "Study reveals that most companies are failing at big data", Nov 2015<br>
          <a href="https://www.cio.com/article/3003538/study-reveals-that-most-companies-are-failing-at-big-data.html"
             target="_blank">
            https://www.cio.com/article/3003538/study-reveals-that-most-companies-are-failing-at-big-data.html
          </a>

        </v-card-text>

      </v-card>


    </v-dialog>





    <!--<section-content title="OUR PURPOSE" :no-side="noSide">-->

      <!--<p>-->
        <!--Today, we are all relying on mathematical models to inform our collective response as a society to-->
        <!--the COVID-19 crisis.  Clearly, any decision predicated on a model's forecast is only as good as the-->
        <!--model used.  Hence, knowing a thing or two about modeling, we decided to spend a bit of time and understand-->
        <!--the models being touted in the news a bit better.  However, what initially started as a small-->
        <!--side project intended to merely pacify our own curiosity has taken on a life of it's own.  And after-->
        <!--not being able to find a COVID-19 forecasting tool that we liked (and believed was credible) we ended up-->
        <!--creating our own.-->
      <!--</p>-->

      <!--<p>-->
        <!--To be clear, we did not create a new model, but rather implemented a slight variant of a very popular and well-->
        <!--known epidemiological model (see the next section for the details).-->

        <!--However, the reason why we believe this tool is useful, (enough for us to make it publicly available) is that-->
        <!--regardless of which epidemiological model is used to predict the effect of a mitigation effort-->
        <!--on COVID-19's trajectory, the critical issue to be resolved is-->
        <!--how to assess the mitigation effort's impact on the model's inputs.-->
      <!--</p>-->

      <!--<p>-->
       <!--For example, in-->
        <!--the model we implemented, one of the critical parameter is the contact probability, or the likelihood that a person-->
        <!--will interact with another person (creating the possibility of the disease to be transmitted from-->
        <!--one person to the other).-->
        <!--While the current contact probability can be estimated from  data, what will the new probability-->
        <!--be if we impose a new mitigation, e.g. a shelter in place order?-->
        <!--Presumably, the probability will reduce, but by how much?  Turns out no one really knows.-->

        <!--Hence, what a researcher must ultimately do is make up this number.  So if the current contact probability-->
        <!--is say 90% one could assume that with shelter in place, the new contact probability  will be-->
        <!--say 70%, or 50%.  Maybe even 10%?   The point is, no one really knows.  While we can do historical-->
        <!--analysis, like <a href="https://www.pnas.org/content/104/18/7582">this paper</a>, to try and-->
        <!--estimate what that effect might be, it is a notoriously difficult task, with at best questionable results.-->
      <!--</p>-->



      <!--<p>-->
        <!--Hence, what we have done is built a tool that everyone can experiment with.  As we consider the various-->
        <!--choices that we can take both collectively as a society as well as those we can individually make, we hope that-->
        <!--this tool can help shed some light on the the impact of those decisions.-->
      <!--</p>-->

      <!--<p>-->
        <!--Finally, we would be remiss if we did not mention, the hopefully obvious, fact that all models are wrong.  While-->
        <!--we have spent considerable effort (well over 100 hours) to ensure that this tool is as good as it could be,-->
         <!--like all models it greatly simplifies reality and as such it should at best be considered-->
        <!--a suggestion of what the future path of COVID-19 might look like.-->
      <!--</p>-->

      <!--&lt;!&ndash;<p>&ndash;&gt;-->
        <!--&lt;!&ndash;As an example, in one of the more widely cited works by Imperial&ndash;&gt;-->
        <!--&lt;!&ndash;College<sup>[{{getr('imperialCovidNPI2020')}}, {{getr('imperialCovidInfluenzaModel')}}]</sup>,&ndash;&gt;-->
        <!--&lt;!&ndash;the authors present findings predicated on the output of stochastic simulation models.&ndash;&gt;-->
        <!--&lt;!&ndash;However, no detailed description of models used in the simulation was given.&ndash;&gt;-->
        <!--&lt;!&ndash;It should be noted that this work&ndash;&gt;-->
        <!--&lt;!&ndash;and the researchers associated with it, play a significant role in determining&ndash;&gt;-->
        <!--&lt;!&ndash;the US government's response to COVID-19.&ndash;&gt;-->
      <!--&lt;!&ndash;</p>&ndash;&gt;-->


      <!--&lt;!&ndash;<p>&ndash;&gt;-->
        <!--&lt;!&ndash;A less extreme example is given in <sup>[{{getr('covid19EarlyDynamics')}}]</sup>, in which the authors provide&ndash;&gt;-->
        <!--&lt;!&ndash;a description of the model employed to estimate the transmission dynamics of COVID-19 using early data from&ndash;&gt;-->
        <!--&lt;!&ndash;Wuhan, however, it is unclear how exactly the authors calibrated their model's parameters, of which there&ndash;&gt;-->
        <!--&lt;!&ndash;were 16.&ndash;&gt;-->
      <!--&lt;!&ndash;</p>&ndash;&gt;-->

      <!--&lt;!&ndash;<p>&ndash;&gt;-->
        <!--&lt;!&ndash;Now to be clear, our position is not that these are poor researchers or that their models were poorly implemented.&ndash;&gt;-->
        <!--&lt;!&ndash;Rather it is that by not providing a detailed account of how their results were obtained,&ndash;&gt;-->
        <!--&lt;!&ndash;we are left to wonder that of the myriad of choices, if perhaps there was not one that if changed would&ndash;&gt;-->
        <!--&lt;!&ndash;have yielded  a different conclusion than the one arrived at by the researchers, which in the case of the&ndash;&gt;-->
        <!--&lt;!&ndash;Imperial College researchers has&ndash;&gt;-->
        <!--&lt;!&ndash;shifted a number of times during this crisis<sup>[{{getr('scienceUncertainty')}}]</sup>.  Which again is&ndash;&gt;-->
        <!--&lt;!&ndash;very much to be expected, given present circumstances.  However, it is the lack of transparency as to why&ndash;&gt;-->
        <!--&lt;!&ndash;their opinions shifted that we find cause for concern.&ndash;&gt;-->

      <!--&lt;!&ndash;</p>&ndash;&gt;-->

      <!--&lt;!&ndash;<p>&ndash;&gt;-->
        <!--&lt;!&ndash;While we have no doubt that all of the researchers whose work we reviewed employ their extensive expertise&ndash;&gt;-->
        <!--&lt;!&ndash;to arrive at&ndash;&gt;-->
        <!--&lt;!&ndash;the best, most defensible conclusions, the reality is we are all human.  We make mistakes, we overlook details,&ndash;&gt;-->
        <!--&lt;!&ndash;especially when faced with the need to deliver results in the mist of a global crisis.&ndash;&gt;-->
        <!--&lt;!&ndash;Hence, the point of transparency is simply to provide a record that allows both ourselves and others to recount&ndash;&gt;-->
        <!--&lt;!&ndash;the precise path along which one must traverse to arrive at the conclusions we posit.  Being unable to recount&ndash;&gt;-->
        <!--&lt;!&ndash;the precise path of research we reviewed, we decided to forge our own path, and to record in detail the choices&ndash;&gt;-->
        <!--&lt;!&ndash;we made along the way.&ndash;&gt;-->
      <!--&lt;!&ndash;</p>&ndash;&gt;-->


      <!--&lt;!&ndash;<div class="title">&ndash;&gt;-->
        <!--&lt;!&ndash;References&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<refs  :refs="bib"></refs>&ndash;&gt;-->
    <!--</section-content>-->
    <!--<div class="pa-2"></div>-->







    <section-content title="THE MODEL" :no-side="noSide">

      <p>
        The basic framework upon which nearly all infectious transmission models are based is the following:
        At the beginning of a viral outbreak, most people will be susceptible
        to the virus as they will have no immunity to it.  Then as more people become infected and recover, herd
        immunity is developed in the population so that there are fewer people left to get infected.  The key questions
        of interest from a societal perspective are:
      </p>

      <div class="mylist">
        <ul>
          <li>How many people will get sick?</li>
          <li>How many people will die? </li>
          <li>How long will the pandemic last? </li>
        </ul>
      </div>




      <!--<p>-->
        <!--Unfortunately, both of these quantities are in general difficult to estimate.  In the case of a pandemic-->
        <!--in its early stages, they nearly impossible to asses accurately.  And as is obvious, if the underlying-->
        <!--assumptions  on which a model is based are themselves inaccurate, then clearly the output of the model will-->
        <!--also be similarly inaccurate.  An iteration of many of the reasons why this is the case is provide by the-->
        <!--folks at FiveThirtyEight <a href="https://fivethirtyeight.com/features/why-its-so-freaking-hard-to-make-a-good-covid-19-model/">here</a>.-->
        <!--While there are some points we take issue with, by and large we agree with their analysis.-->
      <!--</p>-->

      <!--<p>-->
        <!--Hence, if such is the case, then the natural question which arises is what is the use of a model?-->
        <!--With the answer being, if the model was well constructed, even if the parameters upon which it relies are uncertain,-->
        <!--the model yet describes a fundamental relationship between  the variables of interest.  In our case,-->
        <!--the relationship of interest is the effect of "Social Distancing" policies on the infections and deaths-->
        <!--caused by the virus.-->
      <!--</p>-->

      <p>
        Our modeling objective is to answer the questions above as a function of the actions we can take.
        In particular, behavioral mitigations such as closing schools, social distancing, etc.

        To this end, we implemented a slightly modified variant of the standard
        SIR<sup>[{{getr2('mathModReview')}}, {{getr2('mathModReview2')}}]</sup>  (Susceptible, Infectious, Recovery) model.
        The full technical exposition of the model
        may be downloaded <a v-bind:href="url_report">here</a>.

        The basic dynamics of the model are given by
        \begin{align}
        I_{t+1} &= I_t + I^{new}_t  - I^{new}_{t-T^{sick}}  \\
        I^{new}_{t+1} &=  \mathcal{P}_T  \mathcal{P}_C^2  \, \frac{I_t S_t}{P_t}     \\
        S_{t+1} &= S_t - I^{new}_t  \\
        P_{t+1} &= P_t - \mathcal{P}^D I^{new}_{t-T^{sick}}
        \end{align}
        where for time \(t\),  \(I_t\) is the number of infected, \(I^{new}_t\) is the number of new cases introduced,
        \(S_t \) is the number of susceptible individuals in the population,  \(P_t \) is the total population size,
        \(T^{sick}\) is the average number of days a person is sick,  \( \mathcal{P}_C \) is the contact probability, and finally \(\mathcal{P}_T \) is the transmission probability
        or the probability that a person who is exposed to the virus will become sick as a result.
      </p>

      <p>




        <!--with initial conditions-->
        <!--\begin{align}-->
        <!--&P_0 = \text{initial population size} \\-->
        <!--&S_0 = P_0 \\-->
        <!--&I_0 = \text{initial number of cases, must be} \geq  1 \\-->
        <!--&I^{new}_t = 0, \text{ for } t\leq 0-->
        <!--\end{align}-->

      </p>



      <div class="title">
        References
      </div>
      <refs  :refs="bib2"></refs>
    </section-content>




  </div>

</template>






<style scoped lang="scss">

  .slider-box{
    padding-left: 15px;
    padding-right: 15px;
  }

  .slider-text{
    margin-top: -10px;
    font-weight: bold;
    color: #5a5a5a;
  }



  .mylist{
    width: 100%;
  }

  ul{
    padding-bottom: 10px;

    li{
      padding-bottom: 5px;
    }
  }



  .definition{
    font-weight: bold;
    font-style: italic;
  }

  .def-container{
    padding-bottom: 7px;
  }



  .heading-line{
    text-align: center;
    width: 100%
  }



  .main-heading{
    /*min-height: 350px;*/
    display: flex;
    align-items: center;
    justify-content: center;
    /*background-image: url('../assets/images/content/math.png')*/

  }




  .plain-link{
    color: white;
    text-decoration: none;

  }

  .ref_object{
    cursor: pointer;
  }





  img{
    width: 100%;
  }

  .quote{
    max-width: 700px;
    font-style: italic;
    font-size: 0.8em;
  }



  .floated-image{
    float: right;
    max-width: 200px;
    background: red;
    margin-left: 20px;
  }




  .slider_ranges{
    position: absolute; /* Sit on top of the page content */
    /*display: none; !* Hidden by default *!*/
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /*background-color: rgba(0,0,0,0.5); !* Black background with opacity *!*/
    z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */

    .dot{
      fill: #a9a9a9;
    }
  }



  .settings-title{

    padding-top: 10px;
    font-size: small;
    color: #a1a1a1;
  }

</style>



<script>
   // @ is an alias to /src
   import Section from '@/components/Section.vue'
   import SectionContent from '@/components/SectionContent.vue'

   import navBar from '@/components/navBar.vue'
   import CovidChart from '@/components/covid/CovidChart.vue'
   import refs from '@/components/references.vue';
   import highlight from '@/components/covid/overlayHighlight';
   import sliderLabels from '@/components/covid/SliderLabels';

   import _ from 'lodash';

   import helpers from '@/mixins/helpers'


   import {DateTime} from 'luxon';
   import axios from 'axios'


   let data_colors = {
      'Model-Baseline': "#b8b8b8",

      'Model-Forecast': "#8f51ff",

      'Quarantine Period': "#4761ad",
      'Quarantine Period light': "#a8beff",
      'Actual': "#00a6ff",

      'ICU-Baseline': "#b8b8b8",
      'ICU Above Cap-Baseline': "#b8b8b8",

      'ICU Above Cap-Fcst' :  "#8f51ff",
      'ICU-Forecast' :  "#8f51ff",
      'ICU-Capacity' :  "#ff793f",


      'Total Population': "#646464",
      'Susceptible': "#d7d500",
      'Infected': "#ff3223",
      'Recovered': "#12db07",
      'Deaths': "#050505",

   };

   let data_file = '/data/covid_data_2020-04-16.json';

   let updated = '2020-04-16T15:28:09.372Z';


   let trans_prob = 0.45;
   let calibrated_R0 = 0.38; //pre social distancing
   let pC_baseline = Math.sqrt(calibrated_R0/trans_prob)*100;
   let pC_current = 45;

   let R0_adjustment = 0.0;

   let pD_flu = 0.1;  // flu death rate, in percent
   let pD_baseline = 0.5;  //

   let T_sick_base = 10;
   let T_sick_calib = 10;// the T_sick value to use when calibrating the model's growth rate, see documentation


   let ICU_death_multiple = 1; //the multplieer on death rate to use for the ICU need assumption
   let ICU_capacity = 31000; //whole US


   export default {
      name: 'CovidModel',
      mixins: [helpers],
      components: {Section, SectionContent, refs, navBar, CovidChart, highlight, sliderLabels  },
      data(){
         return {

            last_updated: DateTime.fromISO(updated),
            noSide: false,
            colors: data_colors,

            baseUrl: process.env.VUE_APP_BASE_URL,
            covid_data_ts: null, //data from file



            //*****charting data***********************************
            data1: [],
            data2: [],
            data_deaths: [],
            data_all: [],
            data_hist: [],
            data_growth: [],
            data_hospitals: [],

            icu_fcst_above_need: 0,// the number of needed icu beds above capacity


            update_forecast: true, //used to control if forecast is rerun in response to parameter changes

            //********slider controls******************************
            contactProb: pC_current, //pC_baseline*0.8,
            contactProb_max: 100,
            contactProb_min : 0,
            contactProb_step: 1,
            contactProb_labels: ['', '', '', ''],

            transProb: trans_prob*100,
            transProb_max: 80,
            transProb_min: 0,

            deathRate: pD_baseline,
            deathRate_max: 2,
            deathRate_min : 0.0,


            daysInEffect: 30,
            days_max: 30*12,//270,
            days_min: 0,


            daysToReturn: 0,
            daysToReturn_max: 30*12,
            daysToReturn_min: 0,


            dayToStart: 0,
            day_max: 90,
            day_min: 0,

            fcstDays: 360,
            fcstDays_max: 36*30,
            fcstDays_min: 3*30,




            T_sick: T_sick_base,
            T_sick_max: 30,
            T_sick_min: 0,



            maxy: 0,

            //********data for labeling points on the sliders*******
            show_animation: true,
            slider_width: 0,

            //ranges are overwritten in fn compute_slider_highlights()
            ranges_cp: {
               x_baseline: 10,
               x_current: 12,
            },

            ranges_pd : {
              x_flu: 10,
            },

            ranges_daysEffect : [],
            ranges_transProb : [],
            ranges_T_sick : [],
            ranges_fcstDays: [],


            //*****data to control showing charts/control sliders***********************
            show_short: false,
            show_long: true,
            show_full: false,
            show_deaths: false,
            nerdMode: false,
            show_ICU: false,


            show_startDay: false,
            show_fcstDays: false,
            show_DaysNormal: false,

            show_transProb: false,
            show_T_sick: false,
            show_deathRate: false,

            viewMode: 'full', // simple, full
            device: 'desktop', //desktop, mobile
            // device: 'mobile', //desktop, mobile

            btn_toggle_txt: 'Show Full Output',
            btn_nerd_txt: 'Show Nerd Mode',



            //*********options for c3 charts*************************************

            c3_options1: {
               size: {
                  height: 300,
                  // width: 480
               },
               zoom: {enabled: false, rescale: true},
               point:{r: 0},
               data: {
                  x: 't',
                  xSort: false,
                  type: 'area',
                  types: {
                     'Total Population': 'line',
                     'Susceptible': 'line',
                     'Infected': 'line',
                     'Recovered': 'line',
                     'Deaths': 'line',
                  },
                  selection: {enabled: false},
                  columns: [
                     // ['t', '2013-01-01', '2013-01-02', '2013-01-03', '2013-01-04', '2013-01-05', '2013-01-06'],
                     // ['data1', 30, 200, 100, 400, 150, 250],
                     // ['data2', 130, 340, 200, 500, 250, 350]
                  ],

                  colors: data_colors,

               },
               axis: {
                  x: {
                     type: 'timeseries',
                     tick: {
                        format: '%Y-%m-%d',
                        count: 6,
                     }
                  },

                  y: {
                     // label: 'Infected',
                     // min: 0,
                     // max: 300000000,
                     tick: {
                        format:  (d) => {
                           return this.fmt_money(d, 0, '') }
                     }
                  }
               },
               grid: {
                  x: {
                     show: true
                  },
                  y: {
                     show: true
                  },
                  focus:{
                     show:false
                  }
               },
               legend: {show: true},

            },



            c3_options2: {
               size: {
                  height: 300,
                  // width: 480
               },
               zoom: {enabled: false, rescale: true},
               data: {
                  x: 't',
                  xSort: false,
                  type: 'line',
                  order: 'desc',
                  types:{
                     Actual: 'line'
                  },
                  selection: {enabled: false},
                  columns: [
                     // ['t', '2013-01-01', '2013-01-02', '2013-01-03', '2013-01-04', '2013-01-05', '2013-01-06'],
                     // ['data1', 30, 200, 100, 400, 150, 250],
                     // ['data2', 130, 340, 200, 500, 250, 350]
                  ],

                  colors: data_colors,

               },
               axis: {
                  x: {
                     type: 'timeseries',
                     tick: {
                        format: '%Y-%m-%d',
                        count: 6,
                     }
                  },

                  y: {
                     // label: 'Infected',
                     // min: 0,
                     // max: 1000000,
                     tick: {
                        format:  (d) => {
                           if (d > 10)
                            return this.fmt_money(d, 0, '') ;
                           else return d;
                        }

                     }
                  }
               },
               grid: {
                  x: {
                     show: true
                  },
                  y: {
                     show: true
                  },
                  focus:{
                     show:false
                  }
               },
               legend: {show: true},

            },



            show_dialog_ref: false,
            url_report: 'https://espy.ai/data/espy_covid_analysis.pdf',
            bib: [

               {
                  title: 'Science Isn’t A Clear-Cut Pandemic Guide',
                  url: 'https://www.bloomberg.com/opinion/articles/2020-03-31/what-the-coronavirus-models-are-trying-to-tell-us',
                  date: '',
                  org: '',
                  ref: 'scienceUncertainty',
               },
               {
                  title: 'Early dynamics of transmission and control of COVID-19: a mathematical modelling study',
                  url: 'https://www.thelancet.com/journals/laninf/article/PIIS1473-3099(20)30144-4/fulltext#sec1',
                  date: '',
                  org: '',
                  ref: 'covid19EarlyDynamics',
               },

               {
                  title: 'Impact of non-pharmaceutical interventions (NPIs) to reduce COVID19 mortality and healthcare demand',
                  url: 'https://www.imperial.ac.uk/media/imperial-college/medicine/sph/ide/gida-fellowships/Imperial-College-COVID19-NPI-modelling-16-03-2020.pdf',
                  date: '',
                  org: '',
                  ref: 'imperialCovidNPI2020',
               },
               {
                  title: 'Modeling targeted layered containment of an influenza pandemic in the United States',
                  url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2290797/',
                  date: '',
                  org: '',
                  ref: 'imperialCovidInfluenzaModel', //paper related to the above results
               },

               {
                  title: 'Public health interventions and epidemic intensity during the 1918 influenza pandemic',
                  url: 'https://www.pnas.org/content/104/18/7582',
                  date: '',
                  org: '',
                  ref: '1918InterEffe',
               },



            ],


            bib2 : [
               {
                  title: 'Mathematical Modeling of Infectious Disease Dynamics',
                  url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3710332/pdf/viru-4-295.pdf',
                  date: '',
                  org: '',
                  ref: 'mathModReview',
               },
               {
                  title: 'Mathematical Epidemiology: Past, Present, and Future',
                  url: 'https://www.sciencedirect.com/science/article/pii/S2468042716300367',
                  date: '',
                  org: '',
                  ref: 'mathModReview2',
               },
               {
                  title: 'Modelling an influenza pandemic: A guide for the perplexed',
                  url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2717691/',
                  date: '',
                  org: '',
                  ref: '',
               },

               {
                  title: 'Seasonal Influenza Forecasting in Real Time Using the Incidence Decay With Exponential Adjustment Model',
                  url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5781299/',
                  date: '',
                  org: '',
                  ref: '',
               },



               {
                  title: 'Forecasting seasonal influenza with a state-space SIR model',
                  url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5623938/',
                  date: '',
                  org: '',
                  ref: '',
               },

               { //good article with actual math in it
                  title: 'Forecasting national and regional influenza-like illness for the USA',
                  url: 'https://journals.plos.org/ploscompbiol/article?id=10.1371/journal.pcbi.1007013',
                  date: '',
                  org: '',
                  ref: '',
               },

               { //see supplemental info for math
                  title: 'Forecasting seasonal outbreaks of influenza',
                  url: 'https://www.pnas.org/content/early/2012/11/21/1208772109/tab-figures-data',
                  date: '',
                  org: '',
                  ref: '',
               },

               {
                  title: 'A systematic review of studies on forecasting the dynamics of influenza outbreaks',
                  url: 'https://onlinelibrary.wiley.com/doi/full/10.1111/irv.12226',
                  date: '',
                  org: '',
                  ref: '',
               },

               {
                  title: 'Real-time forecasting of an epidemic using a discrete time stochastic model: a case study of pandemic influenza (H1N1-2009)',
                  url: 'https://biomedical-engineering-online.biomedcentral.com/articles/10.1186/1475-925X-10-15',
                  date: '',
                  org: '',
                  ref: '',
               },

               {
                  title: 'Early dynamics of transmission and control of COVID-19: a mathematical modelling study',
                  url: 'https://www.thelancet.com/journals/laninf/article/PIIS1473-3099(20)30144-4/fulltext#sec1',
                  date: '',
                  org: '',
                  ref: 'covid19EarlyDynamics',
               },


               {
                  title: 'Public health interventions and epidemic intensity during the 1918 influenza pandemic',
                  url: 'https://www.pnas.org/content/104/18/7582',
                  date: '',
                  org: '',
                  ref: '1918InterEffe',
               },

            ],




         } //data()
      },

      computed:{
         num_x_ticks(){
            if (['xs'].includes(this.$vuetify.breakpoint.name)){
               return 3;
            }
            else if (['sm'].includes(this.$vuetify.breakpoint.name)){
               return 5;
            }
            else {
               return 7;
            }
         },

         updated_str(){
            return this.last_updated.toLocaleString(DateTime.DATETIME_SHORT);
         },

         annotation_txt_style(){
            if (this.device === 'mobile')
               return "font-size:xx-small";
            else
               return "font-size:x-small";
         },

         annotation_txt_no_social() {
            if (this.device === 'mobile')
               return "No Social Dist";
            else
               return "No Social Distancing";
         },


         update_fcst_baseline(){

           return [this.transProb, this.deathRate,  this.T_sick,
              this.show_short, this.show_long, this.show_full, this.show_deaths, this.nerdMode, this.show_ICU,
              Date.now()];
         },

         update_fcst(){
            return [this.contactProb, this.daysInEffect, this.daysToReturn, Date.now()];
         },

         update_params_cp(){
            return [this.show_T_sick, this.show_startDay, this.show_fcstDays, this.show_transProb, this.show_T_sick,
               this.show_DaysNormal, this.show_deathRate, Date.now()];
         },




      },

      watch:{
         //TODO: simplify this.  see https://github.com/vuejs/vue/issues/844

         update_fcst_baseline(){
            this.param_updated({update_baseline:true});
         },

         fcstDays(){
            this.param_updated({update_baseline:true, checkNt:false});
         },

         update_fcst(){
            this.param_updated();
         },

         update_params_cp(){
            // this.update_url_params();
         },



         slider_width(){
            this.compute_slider_highlights();

         },
      },


      methods:{
         param_updated({update_baseline=false, checkNt=true}={}){

            if (!this.update_forecast) return;

            if (update_baseline){
               this.gen_SIR({gen_baseline:true, checkNt});
               setTimeout(() => {
                  console.log('waited');
                  this.gen_SIR({checkNt});
               }, 500);
            }
            else{
               this.gen_SIR();
            }

            // this.update_url_params();
         },


         update_url_params(){


            let params = [
               'contactProb', 'transProb', 'deathRate', 'daysInEffect', 'daysToReturn','fcstDays',
               'T_sick', 'show_short', 'show_long', 'show_full','show_deaths','nerdMode','show_ICU',
               'show_startDay', 'show_fcstDays', 'show_transProb', 'show_T_sick', 'show_DaysNormal', 'show_deathRate'
            ];

            let query_params = {};
            for (let k of params){
               query_params[k] = this[k];
            }


            this.$router.push({ query: query_params})
               .catch(()=>{console.log("navigation failed: parmeters probably didn't change")})

         },


         set_params_from_url(){
            let params = [
               'contactProb', 'transProb', 'deathRate', 'daysInEffect', 'daysToReturn','fcstDays','T_sick',
            ];

            let params2 = [
               'show_short', 'show_long', 'show_full','show_deaths','nerdMode','show_ICU',
               'show_startDay', 'show_fcstDays', 'show_transProb', 'show_T_sick', 'show_DaysNormal', 'show_deathRate'
            ];


            this.update_forecast = false;
            for (let k of params){
               if (this.$route.query[k] !== undefined){
                  this[k] = Number(this.$route.query[k]);
               }

            }

            for (let k of params2){
               if (this.$route.query[k] !== undefined){
                  if (this.$route.query[k] === true || this.$route.query[k] ==='true')
                  this[k] = true;
               }

            }


            this.gen_SIR({gen_baseline:true});
            setTimeout(() => {
               console.log('waited');
               this.gen_SIR();
               this.update_forecast = true;
            }, 200);

         },


         reset_settings(){
            this.$router.push({ query: {}});
            this.$router.go();
         },





         scroll_to_controls(){
            //https://stackoverflow.com/questions/13735912/anchor-jumping-by-using-javascript
            // document.getElementById('chartSettings').scrollIntoView() ;

            let screen_h = screen.height;
            let el = 'chartSettings';
            var top = document.getElementById(el).offsetTop; //Getting Y of target element
            let height = document.getElementById('chartSettings').offsetHeight; //Getting Y of target element
            top = Math.max(0, top-screen_h+height+15);
            window.scrollTo(0, top);
            console.log('top', top, 'height', height)
         },


         _get_hl_pos(x, low, high, padding){
            return (x - low) /(high-low) * (this.slider_width-padding) + padding/2;
         },
         compute_slider_highlights(){

            this.slider_width = this.$refs.sliderwidth.offsetWidth;
            // console.log('$refs', this.$refs)
            let padding = 16; //padding of the slider container element

            this.ranges_cp = {
               x_baseline: pC_baseline/100*(this.slider_width-padding) + padding/2,
               x_current: pC_current/100*(this.slider_width-padding) + padding/2,
            };

            this.ranges_pd = {
               x_flu: pD_flu/this.deathRate_max*(this.slider_width-padding) + padding/2,
               x_baseline: pD_baseline/this.deathRate_max*(this.slider_width-padding) + padding/2,

            };


            let max = this.days_max;
            let min = this.days_min;
            this.ranges_daysEffect = [
               // {label: '30', x: 30/this.days_max*(this.slider_width-padding) + padding/2},
               {label: '30', x: this._get_hl_pos(30, min, max, padding)},
               {label: '60', x: this._get_hl_pos(60, min, max, padding)},
               {label: '90', x: this._get_hl_pos(90, min, max, padding)},
               {label: '6 M', x: this._get_hl_pos(180, min, max, padding)},
               {label: '9 M', x: this._get_hl_pos(270, min, max, padding)},
               {label: '12 M', x: this._get_hl_pos(360, min, max, padding), align:'end'},
            ];



            max = this.fcstDays_max;
            min = this.fcstDays_min;
            this.ranges_fcstDays = [
               {label: '6 M', x: this._get_hl_pos(6*30, min, max, padding)},
               {label: '12 M', x: this._get_hl_pos(12*30, min, max, padding)},
               {label: '18 M', x: this._get_hl_pos(18*30, min, max, padding)},
               {label: '24 M', x: this._get_hl_pos(24*30, min, max, padding)},
               {label: '36 M', x: this._get_hl_pos(36*30, min, max, padding), align:'end'},
            ];



            max = this.transProb_max;
            min = this.transProb_min;
            this.ranges_transProb = [
               {label: 'Covid-19', x: this._get_hl_pos(trans_prob*100, min, max, padding), align:'start'},
               {label: 'Flu A', x: this._get_hl_pos(31, min, max, padding)},
               {label: 'Flu B', x: this._get_hl_pos(25, min, max, padding)},
               {label: 'SARS', x: this._get_hl_pos(14, min, max, padding)},
            ];


            max = this.T_sick_max;
            min = this.T_sick_min;
            this.ranges_T_sick = [
               {label: 'Current Est.', x: this._get_hl_pos(T_sick_base, min, max, padding)} //(this.slider_width-padding) + padding/2},

            ];
         },


         toggle_viewMode(){

            if (this.device === 'desktop'){
               this.c3_options1.zoom.enabled = true;
               this.c3_options2.zoom.enabled = true;
            }
            else{
               this.c3_options1.zoom.enabled = false;
               this.c3_options2.zoom.enabled = false;
            }




            this.gen_SIR({gen_baseline:true});
            setTimeout(() => {
               console.log('waited');
               this.gen_SIR({pC:this.contactProb, T_sick: this.T_sick});
            }, 500);


            if (this.viewMode === 'simple'){

               this.btn_toggle_txt = 'Show Compact View';
               // this.show_short = false;
               // this.show_long = true;
               // this.show_full = false;
               // this.show_deaths= false;

            }

            else{

               if (this.nerdMode) this.toggle_nerd();
               this.btn_toggle_txt = 'Show Full Model';
               this.viewMode = 'simple';
            }

            this.show_charts();

            if (this.device === 'mobile') setTimeout(()=>{this.scroll_to_controls();}, 100)

         },


         toggle_nerd(){

            this.nerdMode = ! this.nerdMode;

            this.gen_SIR({gen_baseline:true});
            setTimeout(() => {
               console.log('waited');
               this.gen_SIR({pC:this.contactProb, T_sick: this.T_sick});
            }, 500);


            if (this.nerdMode){
               this.btn_nerd_txt = 'Hide Nerd Mode';
            }

            else{
               this.btn_nerd_txt = 'Show Nerd Mode';

               // if (this.device === 'mobile')
               //    window.scrollTo(0, 0);
            }

            if (this.device === 'mobile') setTimeout(()=>{this.scroll_to_controls();}, 100)

         },

         //
         // show_charts(){
         //
         //
         //
         //
         //    if (this.device === 'mobile'){
         //       if (this.viewMode === 'simple'){
         //          this.show_short = false;
         //          this.show_long = true;
         //          this.show_full = false;
         //          this.show_deaths= false;
         //
         //       }
         //
         //       else{
         //          this.show_short = true;
         //          this.show_long = true;
         //          this.show_full = true;
         //          this.show_deaths= true;
         //
         //       }
         //
         //    }
         //
         //    else if (this.device === 'desktop'){
         //
         //       if (this.viewMode === 'simple'){
         //          this.show_short = true;
         //          this.show_long = true;
         //          this.show_full = false;
         //          this.show_deaths= false;
         //
         //       }
         //       else{
         //          this.show_short = true;
         //          this.show_long = true;
         //          this.show_full = true;
         //          this.show_deaths= true;
         //
         //       }
         //    }
         // },



         // /**
         //  * simple function that determins which charts should be shown based on device and viewMode
         //  */
         // show_chart(ix){
         //
         //    let ans;
         //    if (this.device === 'mobile'){
         //
         //       if (this.viewMode === 'simple')
         //          ans =  [1].includes(ix);
         //       else
         //          ans =  true;
         //    }
         //
         //    else if (this.device === 'desktop'){
         //
         //       if (this.viewMode === 'simple')
         //          ans =  [1, 3].includes(ix);
         //       else
         //          ans =  true;
         //    }
         //
         //
         //
         //    return ans;
         // },

         // get's reference for bib referenes
         getr(ref){
            return (this.findWithAttr(this.bib, 'ref', ref)+1).toString();
         },

         getr2(ref){
            return (this.findWithAttr(this.bib2, 'ref', ref)+1).toString();
         },


         /**
          *
          * @param R0in   : adjustment to R0
          * @param N0     : initial population size
          * @param T_sick : recovery time
          * @param pD     : morality rate
          * @param N_t    : number of points to forcast over
          * @param I0     : initial infections
          * @param pT     : transmission probability
          * @param pC     : probability of contact
          * @constructor
          */
         SIR({ gen_baseline=false, checkNt = true}={}){

            let R_0 = this.covid_data_ts.R_0;
            let y = this.covid_data_ts.y;



            // make sure the forecast period covers at least the quarantine period
            let tmp = this.daysInEffect + this.daysToReturn + y.length + 30;
            console.log('max time', tmp, this.fcstDays);
            if (this.fcstDays < tmp && checkNt) {
               this.fcstDays = tmp;
            }


            let pC;
            if (gen_baseline)
               pC = pC_baseline;
            else
               pC = this.contactProb;

            let pD = this.deathRate;
            let N0 = 330000000;
            let T_sick = this.T_sick;
            let N_t = this.fcstDays;
            let pT = this.transProb;

            pC /= 100;
            pD /= 100;
            pT /= 100;






            console.log('T_sick', T_sick, 'N_t', N_t, 'pT', pT, 'pC', pC, 'pD', pD);

            let useHistR0 = true;

            let I = new Array(N_t).fill(0);
            let I_new = new Array(N_t).fill(0);
            let N = new Array(N_t).fill(0);
            let S = new Array(N_t).fill(0);
            let R = new Array(N_t).fill(0);
            let D = new Array(N_t).fill(0);

            let beta = new Array(N_t).fill(0);//used to debug



            // R_0 = [];

            I[0]     = y[0]; //infected
            I_new[0] = y[0]; //num of new cases
            N[0]     =N0; //total population
            S[0]     = N[0]; //num susceptible
            R[0]     = 0; //num recovered
            D[0]     = 0; //num died


            let t0 = DateTime.fromISO(this.covid_data_ts.t[0]);
            let today = DateTime.local();
            let T_today  = today.diff(t0).as('days');


            let hist_cases = 0;// case during the clibration phase that need to be subtracted off later
            var debug = [];
            let dh;


            for (let t=1; t<N_t; t++){
               let Rt = 0;
               let Dt = 0;
               let recovered = 0;
               let R0;

               if (t >= T_sick){
                  Dt = I_new[t - T_sick]*pD;
                  Rt = I_new[t - T_sick] * (1-pD);

                  if (!useHistR0 || t >= R_0.length ) {
                     recovered = I_new[t - T_sick];
                  }
               }
               R[t] = R[t-1] + Rt;
               D[t] = D[t-1] + Dt;


               let pC_0 = pC_baseline/100;

               let t1 = T_today + this.dayToStart;
               let t2 = T_today + this.dayToStart + this.daysInEffect;
               let t3  = T_today + this.dayToStart + this.daysInEffect + this.daysToReturn;

               if (useHistR0){

                  if( t < R_0.length ){
                     R0 = R_0[t-1] ;
                     R0 += R0_adjustment;

                  }
                  else if (t < T_today){
                     // R0 = pT*pC_0*pC_0;
                     R0 = pT*pC*pC;
                  }
                  else if  (t >= t1 && t < t2) //return intervention growth
                     R0 = pT*pC*pC;

                  else if  (t >= t2 && t < t3) {// linearly interpolate between intervention and baseline pC

                     let a = (t-t2)/this.daysToReturn;
                     R0 = pT * pC * pC *(1-a) + pT*pC_0*pC_0* a;
                  }
                  else
                     R0 = pT*pC_0*pC_0;




               }else{
                  pC_0 = pC_baseline/100;
                  if (t < T_today){
                     R0 = pT*pC_0*pC_0;
                  }
                  else if  (t >= T_today + this.dayToStart && t < T_today + this.dayToStart + this.daysInEffect)
                     R0 = pT*pC*pC;
                  else
                     R0 = pT*pC_0*pC_0;
               }

               beta[t] = R0;


               I_new[t] = R0 * I[t-1] * S[t-1] / N[t-1];
               if (I_new[t] < 1) I_new[t] = 0;
               N[t] = N[t-1] - Dt;
               I[t] = I[t-1] + I_new[t] - recovered;
               S[t] =  S[t-1]  - I_new[t];



               //note since we are not subtracking off the historical infections, if we don't do this here, they'll
               //stay in the system forever

               if (useHistR0){
                  if (t <  R_0.length - T_sick) {
                     hist_cases += I_new[t];
                  }
                  else if (t === R_0.length - T_sick)
                     dh = hist_cases*0.05;
                  else if (t >  R_0.length  && t <  R_0.length*2-T_sick){
                     // we're intentionally ignoring y[0] so that we'll always have y[0] cases in the system
                     I[t] -=  I_new[t-R_0.length];
                     hist_cases = Math.max(0, hist_cases - dh);
                     // console.log('i ran')
                  }


                  //if contact probabilty ~ 0, then want everyting to go to zero so am removing the y[0] cases
                  if (t ===  R_0.length && pC < 0.05){
                     I[t] -=  I_new[0];
                  }


                  debug.push(hist_cases)

               }

               // if (I[t] < y[0]) I[t] = y[0]; //needed to make sure we don't have "random resurgences" later
               // if (useHistR0 && t >= y.length && t < y.length *2 - T_sick)
               //    I[t] -= I_new[t-y.length];

            }//for t

            // console.log('beta', beta);
            // console.log('hist cases', debug)

            return {I, N, S, R, D, I_new};
         },

         get_growth_rate(y){
            let n = y.length;
            let g = new Array(n).fill(0);
           for (let i=0; i<n-1; i++){
              g[i] = y[i+1]/y[i] - 1;
           }

           g[n-1] = g[n-2];
           return g;
         },








         gen_SIR({gen_baseline=false, checkNt}={}){

            let N_t = this.fcstDays;

            let t0 = DateTime.fromISO(this.covid_data_ts.t[0]);
            let today = DateTime.local();
            let T_today  = today.diff(t0).as('days');
            T_today = Math.floor(T_today);


            let short_fcst_days = 10;
            let backtest_days = 30;

            let mld = this.SIR({gen_baseline, checkNt });



            //get max value of models
            let maxy = this.maxy*0.05; //this.contactProb/pC_baseline;
            // if (this.data1 != null && this.data1.length > 0){
            //    maxy = Math.max(...mld.I);
            //
            //    // if (this.data1.length > 2){
            //    //    let tmp = Math.max(...this.data1[2].slice(1));
            //    //    maxy = Math.max(tmp, maxy);
            //    // }
            // }

            let n_y = this.covid_data_ts.y.length;

            let T =[];
            let t1 = T_today + this.dayToStart +this.daysInEffect;
            let t2 = T_today + this.dayToStart +this.daysInEffect + this.daysToReturn;
            let affectedDays = [];
            for (let t=0; t<N_t; t++){
               T.push(t0.toFormat('yyyy-LL-dd'));
               t0 = t0.plus({day:1});
               if (t >= T_today + this.dayToStart && t < t1)
                  affectedDays.push(maxy);
               else if (t >= t1 && t < t2){
                  let  a =  (t-t1)/this.daysToReturn;
                  // let  a =  (t - t1)/(t2 - t1);
                  affectedDays.push(maxy *(1-a) + maxy*0 * a);
               }
               else
                  affectedDays.push(null);
            }





            let icu_pred = [];


            if (gen_baseline){
               // let mld = this.gen_SIR({gen_baseline:true});
               this.maxy = Math.max(...mld.I);


               this.data1 =   [
                  ['t'].concat(T),
                  ['Model-Baseline'].concat(mld.I),
                  // ['Actual'].concat(this.covid_data_ts.y),
               ];



               this.data2 = [
                  ['t'].concat(T.slice(0, T_today + short_fcst_days)),
                  // ['Model-Baseline'].concat(mld.I.slice(0, T_today + short_fcst_days)),
                  ['Model-Forecast'].concat(this.covid_data_ts.y).concat(mld.I.slice(n_y, T_today+short_fcst_days)),
                  ['Actual'].concat(this.covid_data_ts.y),

               ];



               this.data_deaths = [
                  ['t'].concat(T),
                  ['Model-Baseline'].concat(mld.D),

               ];

               this.data_all = [
                  ['t'].concat(T),
                  ['Total Population'].concat(mld.N),
                  ['Susceptible'].concat(mld.S),
                  ['Infected'].concat(mld.I),
                  ['Recovered'].concat(mld.R),
                  ['Deaths'].concat(mld.D),

               ];

               this.data_hist = [
                  ['t'].concat(T.slice(0, T_today + backtest_days)),
                  ['Model-Forecast'].concat(mld.I.slice(0, T_today+backtest_days)),
                  ['Actual'].concat(this.covid_data_ts.y),
               ];

               let tmp =this.get_growth_rate(this.data_hist[1].slice(1,));
               this.data_growth=[
                  // ['t'].concat(T),
                  ['t'].concat(T.slice(0, T_today + backtest_days)),
                  ['Model-Forecast'].concat(tmp),
                  ['Actual'].concat(this.get_growth_rate(this.covid_data_ts.y)),
               ];



               // icu_pred = [];
               // let icu_over_cap = [];
               // let over_cap = 0;
               // for (let i in mld.I){
               //    icu_pred.push(mld.I[i] * ICURate_baseline);
               //    over_cap += Math.max(0, mld.I[i] - ICU_capacity);
               //    icu_over_cap.push(over_cap)
               // }




               let over_cap = 0;
               let icu_cap = Array(N_t).fill(0);
               for (let i in icu_cap ){
                  icu_cap[i] = ICU_capacity;
               }

               let icu_over_cap = [];
               icu_pred = [];
               for (let i in mld.I){
                  icu_pred.push(mld.I[i] * this.deathRate/100 * ICU_death_multiple);
                  over_cap += Math.max(0, mld.I[i] - ICU_capacity);
                  icu_over_cap.push(over_cap)
               }

               this.data_hospitals =   [
                  ['t'].concat(T),
                  ['ICU-Capacity'].concat(icu_cap),
                  ['ICU-Baseline'].concat(icu_pred),
                  ['ICU Above Cap-Baseline'].concat(icu_over_cap),


               ];


            }
            else{
               this.data1 =   [
                  ['Model-Forecast'].concat(mld.I),
                  ['Quarantine Period'].concat(affectedDays),
               ];


               this.data2 = [
                  ['Model-Forecast'].concat(this.covid_data_ts.y).concat(mld.I.slice(n_y, T_today+short_fcst_days)),
               ];



               this.data_deaths =   [
                  ['Model-Forecast'].concat(mld.D),
                  // ['Quarantine Period'].concat(affectedDays),
               ];

               this.data_all = [
                  ['t'].concat(T),
                  ['Total Population'].concat(mld.N),
                  ['Susceptible'].concat(mld.S),
                  ['Infected'].concat(mld.I),
                  ['Recovered'].concat(mld.R),
                  ['Deaths'].concat(mld.D),
                  // ['New Cases'].concat(mld.I_new)
               ];



               this.data_hist = [
                  ['Model-Forecast'].concat(mld.I.slice(0, T_today+backtest_days)),
               ];

               let tmp =this.get_growth_rate(this.data_hist[0].slice(1,));
               this.data_growth=[
                  ['Model-Forecast'].concat(tmp),
               ];



               icu_pred = [];
               let icu_over_cap = [];
               let over_cap = 0;
               for (let i in mld.I){
                  icu_pred.push(mld.I[i] * this.deathRate/100 * ICU_death_multiple);
                  over_cap += Math.max(0, mld.I[i] - ICU_capacity);
                  icu_over_cap.push(over_cap)
               }


               this.data_hospitals =   [
                  ['ICU-Forecast'].concat(icu_pred),
                  ['ICU Above Cap-Fcst'].concat(icu_over_cap),
               ];
            }

            //compute icu need
            this.icu_fcst_above_need = 0;

            for (let i in icu_pred){
               this.icu_fcst_above_need += Math.max(icu_pred[i] - ICU_capacity, 0)
            }


            return mld
         },




      },



      mounted(){

         // MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
         MathJax.typeset();


         //note needs to run once the page has loaded




         // console.log('I ran')

      },



      async created(){

         setTimeout(()=>{this.show_animation=false}, 15000);

         window.onresize = this.compute_slider_highlights;
         // window.addEventListener('resize', reportWindowSize);


         this.c3_options1.axis.x.tick.count = this.num_x_ticks;
         this.c3_options2.axis.x.tick.count = this.num_x_ticks;

         this.sort_bib_list(this.bib);
         this.sort_bib_list(this.bib2);

         // console.log(window.location.origin)

         let tmp = await axios.get(window.location.origin+data_file);
         console.log(tmp)
         this.covid_data_ts = tmp.data;
         // let mld = this.gen_SIR({gen_baseline:true});
         // this.maxy = Math.max(...mld.I);


         console.log('query params', this.$route.query);

         if (_.isEmpty(this.$route.query)){
            this.device='desktop';
            if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)){
               // if (screen.width <= 500){

               this.show_long = true;
               this.show_deaths= false;

            }
            else{
               this.show_long = true;
               this.show_deaths= true;

            }


            // this.viewMode='full';
            // this.btn_toggle_txt = 'Show Compact View';
            // if (screen.height <= 1280){
            //    this.viewMode='simple';
            //    this.btn_toggle_txt = 'Show Full Model';
            // }



         }

         else{
            this.set_params_from_url();
         }

         this.param_updated({update_baseline:true});
         setTimeout(()=>{this.compute_slider_highlights(); console.log('add sliders labels 1')}, 500);
         setTimeout(()=>{this.compute_slider_highlights(); console.log('add sliders labels 2')}, 1000);


      }



   }
</script>
